import $ from "jquery";
import { gsap } from "gsap";

export default class Tab {

  public body : HTMLElement;
  private element : HTMLElement;
  private hamburger : HTMLElement;

  constructor() {
    this.body = document.querySelector('body') as HTMLElement;
    this.element = document.querySelector('.header') as HTMLElement;
    this.hamburger = document.querySelector('.js-menu') as HTMLElement;
    // this.subnavSetting();
  }




  init(): void {


    $("[data-tab-nav]").on('click', (event) => {
// .replace("#",'')
        const target = $(event.currentTarget).attr('href') as string;
        const id = target.replace("#",'');
        const $target = $(`[data-tab-content="${id}"]`);
        const $side = $(`[data-tab-side="${id}"]`);
        console.log(target.replace("#",''));

        $("[data-tab-nav]").removeClass('active');
        $("[data-tab-content]").removeClass('active');
        $("[data-tab-side]").removeClass('active');

        $(event.currentTarget).addClass('active');
        $target.addClass('active');
        $side.addClass('active');
    });



  }


}
